import { Injectable } from "@angular/core";
import { SbToastService } from "../../services/iziToast/izitoast.service";
import { UserConfigService } from "../userConfig/user-config.service";
import { DataService } from "../data-request/data-request.service";
import { environment } from "../../environment";

@Injectable({
  providedIn: "root",
})
export class EventCreateService {
  constructor(
    private userConfigService: UserConfigService,
    private dataService: DataService,
    private sbToastService: SbToastService
  ) {}

  /**
   * For get event form config
   */
  getEventFormConfig_old() {
    const req = {
      url: this.userConfigService.getConfigUrl().eventFormConfigApi,
    };
    return this.dataService.get(req);
  }

  getUserData(requestBody) {
    const req = {
      url: this.userConfigService.getConfigUrl().userData,
      data: requestBody,
      header: {
        "Content-Type": "application/json",
      },
    };
    return this.dataService.post(req);
  }

  /**
   * For get event form config
   */
  getEventFormConfig() {
    const requestBody = {
      request: {
        type: "content",
        subtype: "event",
        action: "create",
        // component: "*",
        framework: "*",
        rootOrgId: "0137236500887961602",
      },
    };

    const req = {
      url: this.userConfigService.getConfigUrl().eventFormConfigApi,
      data: requestBody,
      header: {
        "Content-Type": "application/json",
      },
    };

    return this.dataService.post(req);
  }

  /**
   * For post event data
   */
  createEvent(formData) {
    const requestBody = {
      request: {
        event: formData,
      },
    };

    const option = {
      url: this.userConfigService.getConfigUrl().create,
      data: requestBody,
      header: {
        "Content-Type": "application/json",
      },
    };

    return this.dataService.post(option);
  }

  createGmeetEvent(formData, eventId, userId) {
    const formatedSatrtTime = formData.startTime.substring(0, 5);
    const formatedEndTime = formData.endTime.substring(0, 5);
    const requestBody = {
      event_name: formData.name,
      event_id: eventId,
      created_by: userId,
      description: formData.description,
      event_type: formData.eventType,
      start_time: formatedSatrtTime,
      start_date: formData.startDate,
      end_time: formatedEndTime,
      end_date: formData.endDate,
    };

    const option = {
      url: this.userConfigService.getConfigUrl().gmeetcreate,
      data: requestBody,
      header: {
        "Content-Type": "application/json",
        // Authorization:
      },
    };
    console.log(option.url);

    console.log("$$$$$$$$$$", option);

    return this.dataService.post(option);
  }

  updateEvent(formData) {
    const requestBody = {
      request: {
        event: formData,
      },
    };

    const option = {
      url:
        this.userConfigService.getConfigUrl().update +
        "?eventId=" +
        formData["identifier"],
      data: requestBody,
      header: {
        "Content-Type": "application/json",
      },
    };

    return this.dataService.patch(option);

    // this.sbToastService.showIziToastMsg("New Event Created Successfully", 'success');
  }

  getGmeetLink(eventID) {
    const option = {
      url: this.userConfigService.getConfigUrl().gmeetget + eventID,
      header: {
        Accept: "application/json",
      },
    };

    return this.dataService.get(option);
  }

  updateEventwithGmeetLink(formData, identifier, versionKey) {
    const requstBody = {
      request: {
        event: {
          onlineProviderData: {
            meetingLink: formData,
          },
          identifier: identifier,
          versionKey: versionKey,
        },
      },
    };
    const option = {
      url: this.userConfigService.getConfigUrl().update + "?eventId=" + identifier,
      data: requstBody,
      header: {
        "Content-Type": "application/json",
      },
    };

    return this.dataService.patch(option);
  }
  /**
   * For publish event
   */
  publishEvent(identifier) {
    const option = {
      url: this.userConfigService.getConfigUrl().publish + "?eventId=" + identifier,
      header: {
        "Content-Type": "application/json",
      },
    };

    return this.dataService.post(option);
  }
}
